export const telemetryConfiguration = {
  dsn: "https://c0fa9e24039b324f3fd4032a28743ec7@o4506803445104640.ingest.sentry.io/4506803445366784",
  tracesSampleRate: 1,
};
